export default [
  // -------------------------------雲端空間----------------------------------
  {
    path: '/admin/folder',
    name: 'folder',
    component: () => import('@/views/folder/folder-list/FolderList.vue'),
    meta: {
      isAdmin: true,
      contentRenderer: 'sidebar-folder',
      contentClass: 'folder-application',
      // pageTitle: '雲端空間',
      // breadcrumb: [
      //   {
      //     text: '雲端空間',
      //     active: true,
      //   },
      // ],
    },
  },
]
